import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss'],
})
export class ChatBoxComponent {
  @Input() messages = [];
  @Output() sendMessage = new EventEmitter<string>();

  public sendText(text: string) {
    if (text.trim()) {
      this.sendMessage.emit(text);
    }
  }
}
